import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  private readonly protectedKeys = ['language-selected'];

  public clearLocalStorage(): void {
    const savedValues: Record<string, string> = {};

    this.protectedKeys.forEach((key) => {
      const value = localStorage.getItem(key);
      if (value !== null) {
        savedValues[key] = value;
      }
    });

    localStorage.clear();

    Object.entries(savedValues).forEach(([key, value]) => {
      localStorage.setItem(key, value);
    });
  }

  public clearSessionStorage(): void {
    sessionStorage.clear();
  }
}
